import type {BranchRename} from '@github-ui/code-view-types'
import {CopyToClipboardIconButton} from '@github-ui/copy-to-clipboard/IconButton'
import {useCurrentRepository} from '@github-ui/current-repository'
import {useCurrentUser} from '@github-ui/current-user'
import {dismissRepositoryNoticePathPath} from '@github-ui/paths'
import {verifiedFetch} from '@github-ui/verified-fetch'
import {BranchName, Button, Heading, Link, Popover} from '@primer/react'
import {useState} from 'react'

import styles from './BranchRenamePopover.module.css'

export default function BranchRenamePopover({rename}: {rename: BranchRename}) {
  const [hidden, setHidden] = useState(false)
  const currentUser = useCurrentUser()
  const repo = useCurrentRepository()
  const cloneUpdateCommands = `git branch -m ${rename.shellOldName} ${rename.shellNewName}\ngit fetch origin\ngit branch -u origin/${rename.shellNewName} ${rename.shellNewName}\ngit remote set-head origin -a`

  const onDismissPopover = () => {
    if (!currentUser) return
    const dismissPath = dismissRepositoryNoticePathPath({login: currentUser.login})
    const form = new FormData()
    form.append('_method', 'delete')
    form.append('repository_id', repo.id.toString())
    form.append('notice_name', 'repo_default_branch_rename')
    verifiedFetch(dismissPath, {
      method: 'POST',
      body: form,
    })
    setHidden(true)
  }

  return (
    <Popover open={!hidden} caret="top-left" className={styles.Popover}>
      <Popover.Content className={styles.Popover_Content}>
        <Heading as="h4" className={styles.Heading}>
          The default branch has been renamed!
        </Heading>
        <p>
          <BranchName>{rename.oldName}</BranchName> is now named{' '}
          <BranchName className={styles.BranchName}>{rename.newName}</BranchName>
        </p>
        <p className={styles.Text}>
          If you have a local clone, you can update it by running the following commands.
          {rename.shellEscapingDocsURL ? (
            <Link href={rename.shellEscapingDocsURL}>
              Learn about dealing with special characters on the command line.
            </Link>
          ) : null}
        </p>
        <CopyToClipboardIconButton
          textToCopy={cloneUpdateCommands}
          ariaLabel="Copy update commands to clipboard"
          tooltipProps={{style: {position: 'absolute', right: '16px', top: '140px'}}}
        />
        <pre className={styles.Box}>{cloneUpdateCommands}</pre>
        <Button onClick={onDismissPopover}>OK, got it</Button>
      </Popover.Content>
    </Popover>
  )
}
